import { AnalysisEditor } from '../Analysis/AnalysisEditor';
// IMPORT PROJECT REFERENCES
import Can from '../Can';
import PropTypes from 'prop-types';
// IMPORT PACKAGE REFERENCES
import React from 'react';

// COMPONENT
export const AnalysisPage = ({ location }) => (
    <Can I="read" a="ProductAnalysis">
        <AnalysisEditor backLink={location.state ? location.state.backLink : null} />
    </Can>
);

AnalysisPage.propTypes = {
    location: PropTypes.shape({
        state: PropTypes.shape({
            backLink: PropTypes.string,
        }),
    }),
};
